export const workProjects = [
  {
    slug: "ito-insurance-agency",
    name: "I.T.O. Insurance Agency",
    kind: "Insurance",
    url: "https://itoinsuranceagency.com/",
    title: "I.T.O. Insurance Agency",
    description:
      "I.T.O. Insurance Agency on a website that makes complex insurance easier to understand, and on the inquiries that followed the launch.",
    quote:
      "Our new website makes complex insurance look simple. Our clients love how informative it is, and we’ve seen a massive boost in inquiries since launching!",
    paragraphs: [
      "I.T.O. Insurance Agency is one of the client notes published on the ATP Consulting Services homepage. Their review is about a service business whose site had to explain complicated coverage without losing the person reading it.",
      "They said the new website makes complex insurance look simple, that clients find it informative, and that inquiries jumped after launch. That is the reference for a service site whose job is to earn a real inquiry.",
    ],
    related: "total-garage-htx",
  },
  {
    slug: "total-garage-htx",
    name: "Total Garage HTX",
    kind: "Home services",
    url: "https://totalgaragehtx.com/",
    title: "Total Garage HTX",
    description:
      "Total Garage HTX on a site Houston homeowners can find, understand, and use to get in touch.",
    quote:
      "Service and expertise were outstanding from the first call. ATP built us a site that looks as solid as the work we do — homeowners in Houston can find us, understand our services, and reach us without extra friction.",
    paragraphs: [
      "Total Garage HTX is one of the client notes published on the ATP Consulting Services homepage. Their review is about a service business that needed the site to do the same job as the work in the field.",
      "They said homeowners in Houston can find them, understand the services, and reach them without extra friction. That is the reference for a service website that removes steps between the search and the call.",
    ],
    related: "starstruck-nails-spa",
  },
  {
    slug: "starstruck-nails-spa",
    name: "Starstruck Nails & Spa",
    kind: "Salon",
    url: "https://starstrucknailsandspa.com/",
    title: "Starstruck Nails & Spa",
    description:
      "Starstruck Nails & Spa on branding, layout, and a site Tucson clients can recognize.",
    quote:
      "They treated our salon like it mattered. The expertise showed in the details — branding, layout, and how we show up online — and the service stayed personal the whole way through. Tucson clients now see Starstruck the way we intended.",
    paragraphs: [
      "Starstruck Nails & Spa is one of the client notes published on the ATP Consulting Services homepage. Their review is about a salon whose site had to match the way the business actually feels.",
      "They said the details showed up in the branding, the layout, and how they appear online, and that Tucson clients now see Starstruck the way they intended. That is the reference for a local shop site built around the business itself.",
    ],
    related: "ito-insurance-agency",
  },
];
